import { $api } from './interceptor';
import { IAdminBalances } from 'views/types/balances';

const balancesApi = () => {
  const getAdminBalances = async () => {
    const { data } = await $api.get<IAdminBalances>('/api/admin/balances');
    return data;
  };

  return {
    getAdminBalances,
  };
};

export const balanceService = balancesApi();
